import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";

export default function Credential({ number, onDelete }) {
    return (
        <View style={styles.principalView}>
                <Icon name="card-bulleted" size={32} />
                <View style={styles.infoView}>
                    <Text style={styles.titleText}>{"Número"}</Text>
                    <Text style={styles.plateText}>{number}</Text>
                </View>
            <TouchableOpacity  style={{
                    marginLeft: "auto"
                }} onPress={onDelete}>
                <Icon name="trash-can-outline" size={32}  />
            </TouchableOpacity>
        </View>
    )
}

const styles = StyleSheet.create({
    principalView: {
        flexDirection: "row",
        borderRadius: 8,
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 8,
        padding: 8,
        backgroundColor: Colors.SNOW,
        borderColor: Colors.SECONDARY,
        borderLeftWidth: 2,
        shadowColor: Colors.GRAY_DARK,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        borderRadius: 8,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    infoView: {
        marginLeft: 8,
    },
    titleText: {
        fontSize: Fonts.FONT_SIZE_16,
        fontWeight: "300",
        color: Colors.BLACK,
    },
    plateText: {
        fontSize: Fonts.FONT_SIZE_18,
        fontWeight: "500",
        color: Colors.SECONDARY,
    }
})